import { datumDe, datumKompaktDe } from '@/lib/format';
import type { DetailSendungsstand } from '@/types/detail';

// Wortlaut fuer den Sendungsstand einer Position (A12.4).
//
// Die Zahlen und die Einstufung kommen fertig vom Server
// (`positionSendungsstand`); hier wird nur formuliert. Wer die Einstufung
// in der Oberflaeche nachrechnet, hat sie zweimal — und irgendwann
// verschieden (Fallstrick 15).
//
// DREI ZUSTAENDE, NICHT ZWEI
//   „keiner Sendung zugeordnet", „zugeordnet, aber noch im Haus",
//   „draussen". Der Unterschied zwischen den letzten beiden ist der
//   zwischen einem Stapel auf dem Bereit-Tisch und einem Paket beim
//   Zusteller. Wer ihn nicht sieht, sucht das Buch im falschen Raum.

export type SendungsstandAnzeige = {
  text: string;
  /** Steht die Position noch im Haus? Faerbt das Merkzeichen. */
  imHaus: boolean;
};

export function sendungsstandAnzeige(
  stand: DetailSendungsstand,
  menge: number
): SendungsstandAnzeige | null {
  if (stand.art === 'keine') return null;

  if (stand.art === 'bereitgelegt') {
    return {
      text: stand.zugeordnet_vollstaendig
        ? 'Bereitgelegt'
        : `${stand.menge_zugeordnet} von ${menge} bereitgelegt`,
      imHaus: true
    };
  }

  // „Aus dem Haus" fuer den Mischfall: zwei Sendungen, eine abgeholt, eine
  // versendet. „Versendet" waere fuer die eine Haelfte falsch, „Abgeholt"
  // fuer die andere.
  const wort =
    stand.art === 'abgeholt' ? 'abgeholt' : stand.art === 'versendet' ? 'versendet' : 'aus dem Haus';

  if (!stand.vollstaendig) {
    return { text: `${stand.menge_erledigt} von ${menge} ${wort}`, imHaus: false };
  }

  const gross = wort.charAt(0).toUpperCase() + wort.slice(1);
  return {
    text: stand.datum === null ? gross : `${gross} ${datumKompaktDe(stand.datum)}`,
    imHaus: false
  };
}

/**
 * Derselbe Stand als ganzer Satz, fuer die Rueckfrage vor einer Aenderung
 * (A12.5). Nennt das Datum ausgeschrieben — in einer Rueckfrage ist
 * „26.08." zu wenig, wenn die Sendung aus dem Vorjahr stammt.
 */
export function sendungsstandSatz(stand: DetailSendungsstand): string | null {
  if (stand.art === 'keine') return null;
  if (stand.art === 'bereitgelegt') return 'ist für eine Sendung bereitgelegt';

  const wort =
    stand.art === 'abgeholt' ? 'abgeholt' : stand.art === 'versendet' ? 'versendet' : 'aus dem Haus';
  return stand.datum === null ? `wurde ${wort}` : `wurde am ${datumDe(stand.datum)} ${wort}`;
}
